import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppGetState, AppThunkDispatch } from '@/store'
import type { IConfigState } from './types'
import { getTargetOmsConfig } from '@/utils/getConfig'

const initialState: Partial<IConfigState> & { ready: boolean } = {
  ready: false,
}

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig(state, action: PayloadAction<IConfigState>) {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setConfig } = configSlice.actions

export const getConfig = async (dispatch: AppThunkDispatch, getState: AppGetState) => {
  /**
   * 有了就直接返回
   */
  if (typeof getState === 'function' && getState().config?.ready) {
    return getState().config
  }

  const configRes = await getTargetOmsConfig('oneship-config')

  const config = {
    ...configRes,
    ready: true,
  }

  dispatch(setConfig(config))
  return config
}

export default configSlice.reducer
